import Container from 'app/components/common/Container';

import CloudinaryImage from '../common/CloudinaryImage';

export default function SuccesfulNumber({ data }) {
  const URL = data.image?.data?.attributes?.url;
  return (
    URL?.length > 0 && (
      <div className="relative">
        <CloudinaryImage
          backendImgUrl={URL}
          alt={data.image?.data?.attributes?.alternativeText}
          type="isDesktop"
          className="w-full h-full absolute top-0 bottom-0 left-0 right-0"
        />
        <Container className="grid md:grid-cols-12 grid-cols-1 relative z-1">
          <div className="bg-white px-9 lg:py-16 py-8 col-span-4">
            <h5 className="font-[800] xl:text-[50px] md:text-[32px] text-[26px] title_hd leading-tight">
              {data.h1_black} {data.h1_purple}
            </h5>
            <p className="max-w-[1000px] mx-auto md:text-[16px] text-[14px] text-[#000000]">
              {data.p ? data.p : data.body}
            </p>
          </div>
          <div className="flex flex-wrap justify-around w-full col-span-8 items-center md:py-0 py-8">
            {data.section1?.map(experience => (
              <div
                key={experience?.id}
                className="flex flex-col items-center text-white sm:base-1/3 base-1/1 md:p-8 p-4"
              >
                <CloudinaryImage
                  backendImgUrl={experience?.image?.data?.attributes?.url}
                  className="mb-5 w-[40px]"
                  alt={experience?.image?.data?.attributes?.url.alternativeText}
                  type="icon"
                />
                <div className="w-1/2 border-t border-white"></div>
                <p className="text-[24px] font-bold pt-8 mb-3">{`${experience?.num}+`}</p>
                <p className="uppercase">{experience?.text}</p>
              </div>
            ))}
          </div>
        </Container>
      </div>
    )
  );
}
